function initHomeFeaturesCarousel() {
	const carousel = document.querySelector( '[data-features-carousel]' );
	if ( ! carousel ) return;

	const track = carousel.querySelector( '[data-features-track]' );
	const prev = carousel.querySelector( '[data-features-prev]' );
	const next = carousel.querySelector( '[data-features-next]' );
	const dotsWrap = carousel.querySelector( '[data-features-dots]' );
	const cards = track ? Array.from( track.querySelectorAll( '.feature-card' ) ) : [];
	const mediaQuery = window.matchMedia( '(max-width: 767px)' );

	if ( ! track || ! prev || ! next || ! dotsWrap || ! cards.length ) return;

	let dots = [];

	function isMobile() {
		return mediaQuery.matches;
	}

	function getActiveIndex() {
		const center = track.scrollLeft + track.clientWidth / 2;
		let activeIndex = 0;
		let activeDistance = Infinity;

		cards.forEach( ( card, index ) => {
			const cardCenter = card.offsetLeft + card.offsetWidth / 2;
			const distance = Math.abs( center - cardCenter );

			if ( distance < activeDistance ) {
				activeDistance = distance;
				activeIndex = index;
			}
		} );

		return activeIndex;
	}

	function scrollToIndex( index ) {
		const card = cards[ Math.max( 0, Math.min( cards.length - 1, index ) ) ];
		if ( ! card ) return;

		track.scrollTo( {
			left: card.offsetLeft - ( track.clientWidth - card.offsetWidth ) / 2,
			behavior: 'smooth',
		} );
	}

	function updateState() {
		if ( ! isMobile() ) {
			prev.disabled = true;
			next.disabled = true;
			return;
		}

		const activeIndex = getActiveIndex();
		prev.disabled = activeIndex === 0;
		next.disabled = activeIndex === cards.length - 1;

		dots.forEach( ( dot, index ) => {
			dot.classList.toggle( 'is-active', index === activeIndex );
		} );
	}

	function buildDots() {
		dotsWrap.innerHTML = '';
		dots = cards.map( ( _, index ) => {
			const dot = document.createElement( 'span' );
			dot.className = 'features__dot';
			dot.addEventListener( 'click', () => scrollToIndex( index ) );
			dotsWrap.appendChild( dot );
			return dot;
		} );
		updateState();
	}

	prev.addEventListener( 'click', () => scrollToIndex( getActiveIndex() - 1 ) );
	next.addEventListener( 'click', () => scrollToIndex( getActiveIndex() + 1 ) );
	track.addEventListener( 'scroll', () => window.requestAnimationFrame( updateState ), { passive: true } );
	mediaQuery.addEventListener( 'change', updateState );
	window.addEventListener( 'resize', updateState );

	buildDots();
}

export default initHomeFeaturesCarousel;
